import { useCategoryData } from "pages/store";
import React, { useEffect, useState } from "react";
import { Accordion, Form } from "react-bootstrap";
import { useCustomer } from "../actionables/store";

function SubSection1({ slotBookingData, setSlotBookingData }) {
  const { customerData } = useCustomer();
  const [apiSubCategory, setApiSubCategory] = useState([]);
  const { fetchCategoryData, categorySubcatData } = useCategoryData();

  const handleCheckNames = [
    "tabletsUsage",
    "suppliments",
    "timelineSupplements",
    "expectationSetting",
    "usageOfOil",
  ];

  useEffect(() => {
    fetchCategoryData();
  }, []);

  useEffect(() => {
    setApiSubCategory(categorySubcatData?.data?.subcategory);
  }, [categorySubcatData]);

  // Function to handle state change
  const handleCheckboxChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if (handleCheckNames.includes(name)) {
      const checkedValue = event.target.checked;
      setSlotBookingData((prevFormData) => ({
        ...prevFormData,
        [name]: checkedValue,
      }));
    } else {
      setSlotBookingData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const monthsIntoTreatment = customerData.orders;
  return (
    <>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header className="border-bottom">
            How to use
          </Accordion.Header>
          <Accordion.Body>
            <Form.Check
              type="checkbox"
              label="Explained that usage of tablets is either (1-0-1 or 2-0-2)"
              checked={slotBookingData?.tabletsUsage}
              onChange={handleCheckboxChange}
              className="mb-2"
              id="tabletsUsage"
              name="tabletsUsage"
            />
            <Form.Check
              type="checkbox"
              label="Supplements benefits explained"
              checked={slotBookingData?.suppliments}
              onChange={handleCheckboxChange}
              className="mb-2"
              id="suppliments"
              name="suppliments"
            />
            <Form.Check
              type="checkbox"
              label="Explained timeline of supplements"
              checked={slotBookingData?.timelineSupplements}
              onChange={handleCheckboxChange}
              className="mb-2"
              id="timelineSupplements"
              name="timelineSupplements"
            />
            <Form.Group controlId="customerSerum" className="mb-3">
              <Form.Label className="text-primary">
                Type of serum used by the customer
              </Form.Label>
              <Form.Select
                className="form-select"
                value={slotBookingData?.customerSerum}
                name="customerSerum"
                onChange={handleCheckboxChange}
              >
                <option value="Select">Select</option>
                <option value="Recap">Recap</option>
                <option value="Minoxidil">Minoxidil</option>
                <option value="Keto night Lotion">Keto night Lotion</option>
              </Form.Select>
            </Form.Group>
            <div className="d-flex flex-row gap-3 mb-n2">
              <Form.Label className="text-primary">
                Explained Application
              </Form.Label>
              <Form.Check
                inline
                type="radio"
                id="expectYes"
                label="Yes"
                value="Yes"
                checked={
                  slotBookingData?.explainedApplication == "Yes" ? true : false
                }
                required
                name="explainedApplication"
                onChange={handleCheckboxChange}
              />
              <Form.Check
                inline
                type="radio"
                id="expectNo"
                label="No"
                value="No"
                checked={
                  slotBookingData?.explainedApplication == "No" ? true : false
                }
                required
                name="explainedApplication"
                onChange={handleCheckboxChange}
              />
            </div>
            <Form.Check
              type="checkbox"
              label="Performed expectation setting for Minox/ Recap/ Keto"
              checked={slotBookingData?.expectationSetting}
              onChange={handleCheckboxChange}
              className="mb-2"
              id="expectationSetting"
              name="expectationSetting"
            />
            <Form.Check
              type="checkbox"
              label="Explained usage of oil along with serum or lotion"
              checked={slotBookingData?.usageOfOil}
              onChange={handleCheckboxChange}
              className="mb-2"
              id="usageOfOil"
              name="usageOfOil"
            />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
}

export default SubSection1;

// to do dandruff
